<st-map-view
    [mapLockLocation]="viewStateMapLockMapLocation()"
    [mapZoomToCoverage]="viewStateMapZoomToCoverage()"
    [mapCurrentCenter]="viewStateCurrentMapCenter()"
    [mapZoom]="viewStateCurrentZoom()"
    [markerData]="allMarkers()"
    [currentClusterMaxZoom]="currentClusterMaxZoom()"
    (mapCurrentCenterChange)="updateCurrentMapCenter($event)"
    (mapZoomChange)="updateCurrentMapZoom($event)">
    <ng-template
        let-data
        st-item>
        <div (click)="recordClicked(data)">
            @if (data.Type === ObjectTypesEnum.ASSIGNMENT) {
                <div class="st-playbook-map-view-container">
                    <st-icon
                        class="st-playbook-map-view-container__assignment-icon"
                        hasBorder
                        [type]="data?.PSTCoverageType?.id.toUpperCase()"
                        [data]="data" />
                    <div
                        class="st-playbook-map-view-container__title"
                        [title]="data.Title">
                        {{ data.Title }}
                    </div>
                </div>
            }
            @if (data.Type === ObjectTypesEnum.TOPIC) {
                <div class="st-playbook-map-view-container">
                    <div
                        st-topic-icon
                        class="st-playbook-map-view-container__icon"
                        [data]="data"></div>
                    <div
                        class="st-playbook-map-view-container__title"
                        [title]="data.Title">
                        {{ data.Title }}
                    </div>
                </div>
            }
            @if (data.Type === ObjectTypesEnum.USER) {
                <div class="st-playbook-map-view-container">
                    <st-avatar
                        horizontal-big
                        class="st-playbook-map-view-container__avatar"
                        [userId]="getUserID(data)" />
                </div>
            }
        </div>
    </ng-template>
    @if (currentPopupExtraCount > 0) {
        <ng-template *st-footer>
            <span>{{ currentPopupExtraCount }}</span>
            <span>more object</span>
            @if (currentPopupExtraCount > 1) {
                <span>s</span>
            }
        </ng-template>
    }
</st-map-view>
